function padNumber(number) {
  // @ts-ignore: passing a number to parseInt works
  number = parseInt(number);
  if (number < 10) {
    return `0${number}`;
  }
  return number;
}
export default function (offset) {
  if (isNaN(offset)) {
    throw new Error('[timezone-offset-label] You must pass in a number as an offset');
  }
  let absoluteOffset = Math.abs(offset);
  if (offset === 0) {
    return 'UTC';
  } else {
    let sign = offset < 0 ? '-' : '+';
    let hours = padNumber(Math.floor(absoluteOffset));
    let minutes = padNumber(Math.floor(absoluteOffset * 60 % 60));
    return `UTC${sign}${hours}:${minutes}`;
  }
}